import React from "react";
import PropTypes from "prop-types";
import { FormProvider } from "react-hook-form";
import FormFieldMultiSelect from "../../../../components/form-helpers/FormFieldMultiSelect/FormFieldMultiSelect";
import useFilterForm from "../../../../hooks/useFilterForm";
import { toArray } from "../../../../utils/filters";

const GenericFilter = ({
	value,
	onChange = () => {},
	data = [],
	filterKey
}) => {
	const filterValue = React.useMemo(
		() => ({
			[filterKey]: toArray(value?.[filterKey])
		}),
		[value, filterKey]
	);

	const handleChange = React.useCallback(
		newValue => {
			const ids = newValue?.[filterKey] || [];
			onChange(ids);
		},
		[onChange, filterKey]
	);

	const form = useFilterForm({ value: filterValue, onChange: handleChange });

	const options = React.useMemo(
		() =>
			data?.map(item => ({
				value: String(item.id),
				text: item.name
			})) || [],
		[data]
	);

	return (
		<FormProvider {...form}>
			<FormFieldMultiSelect
				name={filterKey}
				options={options}
				search
				value={filterValue[filterKey] || []}
			/>
		</FormProvider>
	);
};

GenericFilter.propTypes = {
	value: PropTypes.object,
	onChange: PropTypes.func,
	data: PropTypes.array,
	filterKey: PropTypes.string.isRequired
};

export default GenericFilter;
